export default __webpack_public_path__ + "static/media/10-new2.933a0f35.png";